import { Field, Float, Int, ObjectType } from '@nestjs/graphql'
import { BaseModelDto } from '../base/baseModel.dto'
import { ArcTeamAutoActionDto } from './autoAction/model.dto'
import { ArcTeamMemberDto } from './member/model.dto'
import { ArcDto } from '../arc'

@ObjectType()
export class ArcTeamDto extends BaseModelDto {
  @Field({ nullable: true })
  name!: string

  @Field({ nullable: true })
  image?: string

  @Field({ nullable: true })
  description?: string

  @Field(t => Int, { nullable: true })
  defaultDisclaimer?: number

  @Field(t => [ArcTeamAutoActionDto], { nullable: true })
  autoActionEmailAddresses?: ArcTeamAutoActionDto[]

  @Field(t => [ArcTeamMemberDto], { nullable: true })
  arcTeamMembers?: ArcTeamMemberDto[]

  @Field(t => [ArcDto], { nullable: true })
  arcs?: ArcDto[]

  @Field(t => ArcTeamMemberDto, { nullable: true })
  clientUserTeamMember?: ArcTeamMemberDto

  @Field()
  isDraft!: boolean

  @Field(t => Int, { nullable: true })
  applicantCount?: number

  /**
   * Active members, counted on the server. The team pages used to fetch every member of every team
   * and count them in the browser [sc-28163].
   */
  @Field(t => Int, { nullable: true })
  memberCount?: number

  @Field(t => Int, { nullable: true })
  followerCount?: number

  @Field({ nullable: true })
  isActivePublisherTeam?: boolean

  @Field({ nullable: true })
  userIsFollowing?: boolean

  @Field(t => Int, { nullable: true })
  reviewCount?: number

  @Field(t => Float, { nullable: true })
  averageRating?: number
}
